import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import 'nprogress/nprogress.css'
import Vuelidate from 'vuelidate'
import VueI18n from 'vue-i18n'
import config from './config.js'
import Echarts from 'echarts'
import moment from 'moment'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import filters from './filters'
import locale from 'element-ui/lib/locale/lang/en'
import Hub from './hub'
import '@/components/svgIcon'
import VueCropper from 'vue-cropper'
import VueVideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import VueClipboard from 'vue-clipboard2'
import {
  initPostHog,
  identifyUser,
  syncPostHogWithStore,
  captureLogin
} from './plugins/posthog'

initPostHog()

Vue.use(VueClipboard)
Vue.use(VueCropper)
Vue.use(VueVideoPlayer)

Vue.config.productionTip = false

Vue.use(Vuelidate)
Vue.use(VueI18n)
Vue.use(ElementUI, { locale })
Vue.prototype.echarts = Echarts
Vue.prototype.$bus = new Vue()
Vue.prototype.$moment = moment
Vue.prototype.$firstLetterCapitalize = word => {
  if (!word) return ''
  return word.charAt(0).toUpperCase() + word.slice(1)
}
Vue.use(Echarts)
Vue.use(Hub)

// register global utility filters
Object.keys(filters).forEach(key => Vue.filter(key, filters[key]))

store.dispatch('locale/initializeLocale')

const i18n = new VueI18n({
  locale: store.getters['locale/GetCurrentLocale'],
  fallbackLocale: 'en',
  messages: config.supported_languages
})

export const app = new Vue({
  data() {
    return {
      screenWidth: window.innerWidth
    }
  },
  router,
  store,
  i18n,
  render: h => h(App),
  created() {
    const user = localStorage.getItem('user')
    if (user) {
      const userData = JSON.parse(user)
      this.$store.commit('user/SET_USER_DATA', userData)
      // Session restored from localStorage on app load, no user interaction.
      identifyUser(this.$store)
      captureLogin('silent')
    }
    syncPostHogWithStore(this.$store)
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.screenWidth = window.innerWidth
    })
  }
}).$mount('#app')
